import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";

import { updateUserInfo } from "../../auth/authSlice";

import { UploadFile } from "@mui/icons-material";

const LogoUploadBox = () => {
  const dispatch = useDispatch();

  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  // 드래그 오버 시 기본 이벤트 제거
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // 파일 드롭 시 파일 선택 처리
  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setSelectedFile(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  // 파일 입력 변화 처리
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedFile(e.target.files[0]);
    }
  };

  // 업로드 버튼 클릭 시 API 호출
  const handleUpload = async () => {
    if (!selectedFile) {
      alert("이미지를 선택해주세요.");
      fileInputRef.current.click();
      return;
    }

    const formData = new FormData();
    formData.append("logo_img", selectedFile);
    dispatch(updateUserInfo(formData));
    alert("로고 이미지가 변경되었습니다.");
  };

  return (
    <div style={{ padding: "16px" }}>
      <div
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current.click()}
        style={{
          position: "relative",
          border: "2px dashed #ccc",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          cursor: "pointer",
        }}
      >
        {selectedFile ? (
          <img
            src={URL.createObjectURL(selectedFile)}
            alt="미리보기"
            style={{ width: "100%", maxHeight: "150px", objectFit: "contain" }}
          />
        ) : (
          <div
            style={{
              padding: "40px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <UploadFile
              style={{
                color: "#438CFB",
                fontSize: "160px",
              }}
            />
            <div style={{ fontSize: "20px" }}>
              {"업로드할 사진을 이곳에 드래그하세요."}
            </div>
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleUpload();
          }}
          style={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            padding: "3px 30px",
            backgroundColor: "#2D2D2D",
            color: "#fff",
            fontSize: "16px",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          변경하기
        </button>
      </div>
    </div>
  );
};

export default LogoUploadBox;
